import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon'
import CurrencyInput from '@/components/form/CurrencyInput.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('CurrencyInput', CurrencyInput)
